<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="选项名称 搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col :span="18" v-if="!optionStatus || !optionStatus.length">
            <el-form-item label="有效状态">
              <el-select v-model="optionStatus" multiple clearable filterable>
                <el-option label="有效" value="Y"></el-option>
                <el-option label="无效" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="选项名">
              <el-input
                v-model="form.optionLabel"
                placeholder="请输入选项名称"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选项值">
              <el-input
                v-model="form.optionValue"
                placeholder="选项值"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="字典类型">
              <dict-select
                v-model="form.bizSysDictCode"
                url="/openapi/client/dict/dictSelect"
                placeholder="请选择字典类型"
                filterable
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  optionStatusList: ['Y'],
}
export default {
  props: {optionStatus: {type: Array, default: () => []}},
  data() {
    return {
      advqueryDialogVisible: false,
      form: {...initForm},
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const status =
        this.optionStatus && this.optionStatus.length
          ? this.optionStatus
          : this.form.optionStatusList
      this.$emit('query', {
        ...this.form,
        optionStatusList: status,
        optionStatus: status,
      })
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = {...initForm}
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
